import {TeamMembership} from "./TeamMembership";

export class Team {
  constructor(
    public readonly id: string,
    public readonly name: string,
    public readonly startedAt: Date,
    public readonly endedAt: Date|null,
    public readonly members: TeamMembership[],
    public readonly order: number,
    public readonly capacity: number|null,
    public readonly isTemporary: boolean,
    public readonly category: string,
  ) {}

  static fromJson(json: any): Team {
    return new Team(
      json['id'],
      json['name'],
      new Date(json['started_at']),
      json['ended_at'] ? new Date(json['ended_at']) : null,
      json['members'] ? json['members'].map(TeamMembership.fromJson) : [],
      json['order'] ?? 0,
      json['capacity'] ?? null,
      json['is_temporary'],
      json['category'],
    )
  }
}